export const MOCK_API_URL = "http://localhost";

export const OAUTH = "/oauth";
export const TOKEN = "/token";
export const USER_CONFIG = "/users/self";

export const KNOWLEDGE_ENTRY = "/knowledge/fragments";
export const ANALYTICS_EVENTS = "/analytics/events";
export const DOCUMENTS = "/documents";
